import { render, staticRenderFns } from "./TaxonomySetting.vue?vue&type=template&id=07001900&"
import script from "./TaxonomySetting.vue?vue&type=script&lang=js&"
export * from "./TaxonomySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports